export var ToggleLabelPosition;
(function (ToggleLabelPosition) {
    ToggleLabelPosition["LEFT"] = "left";
    ToggleLabelPosition["RIGHT"] = "right";
})(ToggleLabelPosition || (ToggleLabelPosition = {}));
export var ToggleLabelAppearance;
(function (ToggleLabelAppearance) {
    ToggleLabelAppearance["DEFAULT"] = "default";
    ToggleLabelAppearance["HIGH_CONTRAST"] = "high-contrast";
})(ToggleLabelAppearance || (ToggleLabelAppearance = {}));
//# sourceMappingURL=oh-toggle.types.js.map
